import { Grid } from '@mui/material';
import { OrganizationData } from '@ysura/common';

import { OrganizationPersonDataStaticBlock } from '@/components/Organization';
import { PersonDataSkeletonStaticBlock } from '@/components/PersonData';

interface OrganizationPersonsCardProps {
  organization?: OrganizationData;
  isLoading?: boolean;
}
export const OrganizationPersonsCard = ({
  organization,
  isLoading,
}: OrganizationPersonsCardProps) => {
  if (isLoading) {
    return (
      <Grid>
        <PersonDataSkeletonStaticBlock
          title={'pages.organizationView.personDataCard.personData'}
        />
      </Grid>
    );
  }

  return (
    <Grid>
      <>
        {organization && (
          <OrganizationPersonDataStaticBlock organization={organization} />
        )}
      </>
    </Grid>
  );
};
